(function () {
  var searchUtils = window.CityGuideSearchUtils || {};
  var normalize =
    searchUtils.normalizeSearchValue ||
    function (value) {
      return String(value || "")
        .toLowerCase()
        .trim();
    };
  var compact =
    searchUtils.compactSearchValue ||
    function (value) {
      return normalize(value).replace(/\s+/g, "");
    };
  var toNumber =
    searchUtils.toNumber ||
    function (value) {
      var number = parseFloat(value);
      return Number.isFinite(number) ? number : null;
    };
  var calculateDistanceMiles =
    searchUtils.calculateDistanceMiles ||
    function () {
      return Number.POSITIVE_INFINITY;
    };

  var geoapifyAbortController = null;
  var geoCache = {};

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function normalizeUrl(url) {
    return searchUtils.normalizeUrl
      ? searchUtils.normalizeUrl(url)
      : String(url || "");
  }

  function getDefaultImageSvg() {
    return (
      '<span class="cities-hero-search-result__image cities-hero-search-result__image--placeholder" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" focusable="false">' +
      '<path d="M12 21s7-6.18 7-12A7 7 0 0 0 5 9c0 5.82 7 12 7 12Z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>' +
      '<circle cx="12" cy="9" r="2.5" fill="none" stroke="currentColor" stroke-width="1.7"/>' +
      "</svg>" +
      "</span>"
    );
  }

  function getCityTitle(city) {
    return city.cityName || city.title || city.name || "";
  }

  function getCityUrl(city) {
    return normalizeUrl(city.cityUrl || city.url || city.cityPageUrl || "");
  }

  function parseCities(rawCities) {
    var parsed = (
      searchUtils.parseCityHubs
        ? searchUtils.parseCityHubs(rawCities)
        : rawCities || []
    )
      .map(function (city) {
        return {
          cityName: getCityTitle(city),
          title: getCityTitle(city),
          cityUrl: getCityUrl(city),
          url: getCityUrl(city),
          cityImage: city.cityImage || city.image || "",
          citySmallDescription:
            city.citySmallDescription || city.description || "",
          state: city.state || "",
          stateCode: city.stateCode || "",
          lat: toNumber(city.lat || city.latitude),
          lng: toNumber(city.lng || city.longitude),
        };
      })
      .filter(function (city) {
        return !!(city.cityName && city.cityUrl);
      });
    var seen = {};

    return parsed.filter(function (city) {
      var key = compact(city.cityUrl || city.cityName);
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function buildCitySearchText(city) {
    return normalize(
      [city.cityName, city.state, city.stateCode, city.citySmallDescription]
        .filter(Boolean)
        .join(" "),
    );
  }

  function getLocalCityMatches(query, cities) {
    var normalizedQuery = normalize(query);
    var compactQuery = compact(query);

    if (!normalizedQuery) return [];

    return cities
      .map(function (city) {
        var title = normalize(city.cityName);
        var cityText = buildCitySearchText(city);
        var score = 0;

        if (compact(city.cityName) === compactQuery) {
          score = 110;
        } else if (cityText.indexOf(normalizedQuery) !== -1) {
          score = normalizedQuery.length > 2 ? 70 : 35;
        } else if (normalizedQuery.indexOf(title) !== -1 && title.length > 2) {
          score = 65;
        }

        return Object.assign({}, city, {
          score: score,
          matchLabel: "",
        });
      })
      .filter(function (city) {
        return city.score > 0;
      })
      .sort(function (a, b) {
        return b.score - a.score;
      });
  }

  function cityFromMappingHub(match) {
    var mapping = match && match.mapping ? match.mapping : null;
    var hub =
      match && match.hub
        ? match.hub
        : match && match.hubs
          ? match.hubs[0]
          : null;

    if (!mapping && !hub) return null;

    return {
      cityName:
        (hub && (hub.cityName || hub.title)) || mapping.parentCityPageTitle,
      title:
        (hub && (hub.cityName || hub.title)) || mapping.parentCityPageTitle,
      cityUrl: (hub && (hub.cityUrl || hub.url)) || mapping.parentCityPageUrl,
      url: (hub && (hub.cityUrl || hub.url)) || mapping.parentCityPageUrl,
      cityImage: (hub && (hub.cityImage || hub.image)) || "",
      citySmallDescription:
        match.kind === "zip"
          ? "Closest city guide for " + mapping.displayName
          : "Matches " + (mapping.displayName || mapping.searchCity),
      state: (hub && hub.state) || mapping.state || "",
      stateCode: (hub && hub.stateCode) || mapping.stateCode || "",
      lat: hub && hub.lat !== null ? hub.lat : mapping.lat,
      lng: hub && hub.lng !== null ? hub.lng : mapping.lng,
      score: 140,
      matchLabel: "",
    };
  }

  function dedupeResults(results) {
    var seen = {};

    return results.filter(function (result) {
      var key = compact(result.cityUrl || result.url || result.cityName);
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function renderResults(results, elements, options) {
    var label = (options && options.label) || "Top Results";

    elements.heading.textContent = label;
    elements.list.innerHTML = results
      .slice(0, 6)
      .map(function (city) {
        var title = escapeHtml(city.cityName || city.title);
        var desc = escapeHtml(city.matchLabel || "");
        var image = city.cityImage || city.image;
        var imageHtml = image
          ? '<img class="cities-hero-search-result__image" src="' +
            escapeHtml(image) +
            '" alt="" loading="lazy">'
          : getDefaultImageSvg();

        return (
          '<li class="cities-hero-search-result__item">' +
          '<a class="cities-hero-search-result__link" href="' +
          escapeHtml(city.cityUrl || city.url) +
          '">' +
          '<figure class="cities-hero-search-result__figure">' +
          imageHtml +
          "</figure>" +
          '<span class="cities-hero-search-result__info">' +
          '<span class="cities-hero-search-result__item-title">' +
          title +
          "</span>" +
          "</span>" +
          "</a>" +
          "</li>"
        );
      })
      .join("");

    elements.empty.hidden = results.length > 0;
    elements.container.hidden = false;
    elements.container.classList.add("is-active");
    if (options && options.status) {
      elements.container.setAttribute("data-status", options.status);
    } else {
      elements.container.removeAttribute("data-status");
    }
    if (elements.root) elements.root.classList.add("is-search-active");
    elements.input.setAttribute("aria-expanded", "true");

    if (elements.nearbyWrap) {
      elements.nearbyWrap.hidden = options && options.hideNearby === true;
    }

    if (elements.announcer) {
      elements.announcer.textContent = results.length
        ? results.length + " city results available."
        : "No city results found.";
    }
  }

  function hideResults(elements) {
    elements.container.classList.remove("is-active");
    if (elements.root) elements.root.classList.remove("is-search-active");
    elements.container.hidden = true;
    elements.input.setAttribute("aria-expanded", "false");
  }

  function setNearbyState(buttons, state) {
    buttons.forEach(function (button) {
      button.classList.toggle("is-loading", state === "loading");
      button.disabled = state === "loading";
    });
  }

  function getGeoapifyUrl(query, apiKey) {
    var trimmedQuery = String(query || "").trim();
    var encodedQuery = encodeURIComponent(trimmedQuery);
    var encodedApiKey = encodeURIComponent(apiKey || "");

    return (
      "https://api.geoapify.com/v1/geocode/search?text=" +
      encodedQuery +
      "&limit=5&format=geojson&apiKey=" +
      encodedApiKey
    );
  }

  function extractGeoapifyCandidates(data) {
    var rawResults = data && Array.isArray(data.features) ? data.features : [];

    return rawResults
      .map(function (feature) {
        var properties =
          feature && feature.properties ? feature.properties : {};
        var coordinates =
          feature &&
          feature.geometry &&
          Array.isArray(feature.geometry.coordinates)
            ? feature.geometry.coordinates
            : [];
        var lat = toNumber(coordinates[1]);
        var lng = toNumber(coordinates[0]);

        if (!feature || lat === null || lng === null) return null;

        return {
          name:
            properties.city ||
            properties.town ||
            properties.village ||
            properties.county ||
            properties.name ||
            properties.formatted ||
            "",
          country: properties.country || properties.country_code || "",
          state: properties.state || "",
          stateCode: properties.state_code || "",
          lat: lat,
          lng: lng,
        };
      })
      .filter(Boolean);
  }

  function resolveGeoLocation(query, apiKey) {
    var cacheKey = "cities_search_geoapify_v1_" + compact(query);

    if (!apiKey || !String(query || "").trim()) return Promise.resolve(null);
    if (Object.prototype.hasOwnProperty.call(geoCache, cacheKey)) {
      console.log("[Cities Search] Geoapify cache hit", {
        query: query,
        value: geoCache[cacheKey],
      });
      return Promise.resolve(geoCache[cacheKey]);
    }

    try {
      var stored = JSON.parse(sessionStorage.getItem(cacheKey) || "null");
      if (stored && Date.now() - stored.timestamp < 1000 * 60 * 60) {
        geoCache[cacheKey] = stored.value;
        console.log("[Cities Search] Geoapify sessionStorage hit", {
          query: query,
          value: stored.value,
        });
        return Promise.resolve(stored.value);
      }
    } catch (error) {
      // Ignore storage failures.
    }

    if (geoapifyAbortController) geoapifyAbortController.abort();
    geoapifyAbortController =
      "AbortController" in window ? new AbortController() : null;

    console.log("[Cities Search] Calling Geoapify fallback", {
      query: query,
      endpoint: getGeoapifyUrl(query, apiKey).replace(
        /apiKey=[^&]+/,
        "apiKey=***",
      ),
    });

    return fetch(getGeoapifyUrl(query, apiKey), {
      signal: geoapifyAbortController
        ? geoapifyAbortController.signal
        : undefined,
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Geoapify request failed");
        return response.json();
      })
      .then(function (data) {
        var value = extractGeoapifyCandidates(data)[0] || null;

        console.log("[Cities Search] Geoapify response", {
          query: query,
          rawFeatureCount:
            data && Array.isArray(data.features) ? data.features.length : 0,
          selectedLocation: value,
        });

        geoCache[cacheKey] = value;
        try {
          sessionStorage.setItem(
            cacheKey,
            JSON.stringify({
              timestamp: Date.now(),
              value: value,
            }),
          );
        } catch (error) {
          // Ignore storage failures.
        }

        return value;
      })
      .catch(function (error) {
        if (error && error.name === "AbortError") return null;
        console.log("[Cities Search] Geoapify failed", {
          query: query,
          error: error && error.message ? error.message : error,
        });
        return null;
      });
  }

  function getNearestCities(lat, lng, cities, limit) {
    return cities
      .filter(function (city) {
        return city.lat !== null && city.lng !== null;
      })
      .map(function (city) {
        var distance = calculateDistanceMiles(lat, lng, city.lat, city.lng);

        return Object.assign({}, city, {
          distance: distance,
          matchLabel: "",
        });
      })
      .sort(function (a, b) {
        return a.distance - b.distance;
      })
      .slice(0, limit || 6);
  }

  function buildSearchResults(query, cities, locationMappings) {
    var mappingMatch = searchUtils.resolveLocationMapping
      ? searchUtils.resolveLocationMapping(query, locationMappings)
      : null;
    var mappingCity = cityFromMappingHub(mappingMatch);
    var localMatches = getLocalCityMatches(query, cities);

    return dedupeResults(
      mappingCity ? [mappingCity].concat(localMatches) : localMatches,
    );
  }

  function initCitiesHeroSearch() {
    var input = document.getElementById("hero-search");
    var form = input ? input.closest("form") : null;
    var searchButton = form ? form.querySelector(".cities-hero__button") : null;
    var sectionRoot = input ? input.closest(".cities-hero") : null;
    var nearbyButtons = Array.prototype.slice.call(
      document.querySelectorAll("[data-nearby-location-trigger]"),
    );
    var elements = {
      root: sectionRoot,
      input: input,
      container: document.getElementById("search-results-container"),
      list: document.getElementById("search-results-list"),
      empty: document.getElementById("search-no-results"),
      heading: document.getElementById("search-results-heading"),
      announcer: document.getElementById("search-announcer"),
      nearbyWrap: document.querySelector(
        ".cities-hero-search-result__nearby-wrap",
      ),
    };
    var geoapifyApiKey =
      (sectionRoot && sectionRoot.dataset.geoapifyApiKey) ||
      window.citiesSearchGeoapifyApiKey ||
      "";
    var cities = parseCities(window.citiesSearchData || []);
    var locationMappings = searchUtils.parseLocationMappings
      ? searchUtils.parseLocationMappings(
          window.citiesSearchLocationMappings || [],
          cities,
        )
      : [];
    var suggestions = parseCities(window.citiesSearchSuggestions || []);
    var debounceTimer = null;

    if (
      !input ||
      !elements.container ||
      !elements.list ||
      !elements.empty ||
      !elements.heading
    ) {
      return;
    }

    function scrollSearchIntoView() {
      var searchWrap = input.closest(".cities-hero__search") || form;
      var rect;
      var targetTop;

      if (!searchWrap) return;

      rect = searchWrap.getBoundingClientRect();
      if (rect.top >= 24 && rect.top <= window.innerHeight * 0.28) return;

      targetTop = window.pageYOffset + rect.top - 24;
      window.scrollTo({
        top: Math.max(targetTop, 0),
        behavior: "smooth",
      });
    }

    function showQueryResults(query, options) {
      var results = buildSearchResults(query, cities, locationMappings);

      if (results.length) {
        console.log("[Cities Search] Shopify/metaobject match used", {
          query: query,
          count: results.length,
          results: results.map(function (result) {
            return {
              title: result.cityName || result.title,
              url: result.cityUrl || result.url,
            };
          }),
        });
        renderResults(results, elements, options);
        return Promise.resolve(results);
      }

      if (!geoapifyApiKey || normalize(query).length < 2) {
        renderResults([], elements, options);
        return Promise.resolve([]);
      }

      return resolveGeoLocation(query, geoapifyApiKey).then(
        function (geoLocation) {
          var nearest = geoLocation
            ? getNearestCities(geoLocation.lat, geoLocation.lng, cities, 6)
            : [];

          console.log("[Cities Search] Nearest guides from Geoapify point", {
            query: query,
            geoLocation: geoLocation,
            nearest: nearest.map(function (city) {
              return {
                title: city.cityName || city.title,
                milesDirect: Math.round(city.distance),
              };
            }),
          });

          renderResults(nearest, elements, {
            label: nearest.length ? "Nearest City Guides" : "Top Results",
          });
          return nearest;
        },
      );
    }

    function submitSearch(event) {
      var query = input.value.trim();

      if (event) event.preventDefault();
      if (!query) {
        input.focus();
        renderResults(suggestions.slice(0, 6), elements, {
          label: "Popular Cities",
        });
        return;
      }

      showQueryResults(query).then(function (results) {
        if (results[0] && results[0].cityUrl) {
          window.location.href = results[0].cityUrl;
        }
      });
    }

    function requestNearbyLocation(event) {
      if (event) event.preventDefault();
      scrollSearchIntoView();

      if (!navigator.geolocation) {
        renderResults([], elements, { label: "Nearby Cities" });
        if (elements.announcer) {
          elements.announcer.textContent =
            "Location is unavailable in this browser.";
        }
        return;
      }

      setNearbyState(nearbyButtons, "loading");

      navigator.geolocation.getCurrentPosition(
        function (position) {
          var coords = position && position.coords ? position.coords : null;
          var nearby = coords
            ? getNearestCities(coords.latitude, coords.longitude, cities, 6)
            : [];

          setNearbyState(nearbyButtons, "ready");
          renderResults(nearby, elements, {
            label: "Cities Near You",
            hideNearby: true,
            status: "Using your current location",
          });
        },
        function () {
          setNearbyState(nearbyButtons, "error");
          if (elements.announcer) {
            elements.announcer.textContent =
              "Location access was denied or unavailable.";
          }
        },
        {
          enableHighAccuracy: false,
          timeout: 10000,
          maximumAge: 1000 * 60 * 15,
        },
      );
    }

    input.addEventListener("focus", function () {
      scrollSearchIntoView();

      if (input.value.trim()) {
        showQueryResults(input.value.trim());
      } else if (suggestions.length) {
        renderResults(suggestions.slice(0, 6), elements, {
          label: "Popular Cities",
        });
      }
    });

    input.addEventListener("input", function () {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(function () {
        var query = input.value.trim();

        if (!query) {
          if (suggestions.length) {
            renderResults(suggestions.slice(0, 6), elements, {
              label: "Popular Cities",
            });
          } else {
            hideResults(elements);
          }
          return;
        }

        showQueryResults(query);
      }, 220);
    });

    document.addEventListener("click", function (event) {
      if (!event.target.closest(".cities-hero__search")) hideResults(elements);
    });

    input.addEventListener("keydown", function (event) {
      if (event.key === "Escape") hideResults(elements);
    });

    if (form) form.addEventListener("submit", submitSearch);
    if (searchButton) searchButton.addEventListener("click", submitSearch);

    nearbyButtons.forEach(function (button) {
      button.addEventListener("click", requestNearbyLocation);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCitiesHeroSearch);
  } else {
    initCitiesHeroSearch();
  }
})();
